import React from 'react';
import { Link } from 'react-router-dom';
function StubPage({
  title
}: {
  title: string;
}) {
  return <div className="min-h-screen pt-32 pb-20 px-6 flex flex-col items-center justify-center text-center" data-id="element-1983">
      <p className="text-[10px] font-bold text-[#9A9A90] uppercase tracking-[0.25em] mb-4" data-id="element-1984">
        Coming Soon
      </p>
      <h1 className="text-5xl md:text-7xl font-serif text-white mb-8" data-id="element-1985">
        {title}
      </h1>
      <div className="w-12 h-0.5 bg-tealslate mb-8 mx-auto" data-id="element-1986" />
      <p className="text-[#D8D8D0] max-w-md mx-auto mb-10" data-id="element-1987">
        This page is currently under construction. Check back soon for updates.
      </p>
      <Link to="/" className="inline-flex items-center justify-center px-8 py-4 bg-tealslate text-white text-sm font-bold uppercase tracking-wider hover:bg-lightteal transition-colors" data-id="element-1988">
        Return Home
      </Link>
    </div>;
}
export const About = () => <StubPage title="About Jack" data-id="element-1989" />;
export const Guide = () => <StubPage title="The Guide" data-id="element-1990" />;